import { Base } from "../core/base.model";

export class ConfiguracionGeneral extends Base{
    public conf_fol_pr: string;
	public conf_fol_se: number;
	public conf_fol_se_dsc: string;
	public valor1: string;
	public valor2: string;
	public valor3: string;
	public valor4: string;
	public desc01: string;
	public desc02: string;
	public desc03: string;
	public desc04: string;
	public num_cliente: string;
	public nombre: string;
	public codigoError: string;
	public error: string;
}
